export enum SidebarMode {
    OPEN = 'open',
    CLOSE = 'close'
}
